import React from 'react';
import { Button, Dialog, Heading, Modal, ModalOverlay } from 'react-aria-components';
import SvgIcon from '../../utils/SvgIcon';

type BaseModalProps = Readonly<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  children: React.ReactNode;
  modalClassName?: string;
  dialogClassName?: string;
  closeAriaLabel?: string;
}>;

export default function BaseModal(props: BaseModalProps) {
  const { isOpen, onOpenChange, title, children, modalClassName, dialogClassName, closeAriaLabel = 'Close' } = props;

  return (
    <ModalOverlay isDismissable isOpen={isOpen} onOpenChange={onOpenChange} className={`modal ${modalClassName || ''}`}>
      <Modal>
        <Dialog className={`modal__content ${dialogClassName || ''}`}>
          <div className="modal__content-inner">
            <Heading slot="title" level={2} className="modal__heading">
              {title}
            </Heading>
            {children}
            <Button slot="close" aria-label={closeAriaLabel} className="modal__close">
              <SvgIcon iconName="x-mark" viewBox="0 0 24 24" />
            </Button>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
